import React, {useState, useEffect, useRef, Fragment} from 'react';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import useStyles from '../styles/styles';
import getEnvironment from "../utils/getEnvironment";
import {
    Backdrop,
    Box,
    Button,
    CircularProgress,
    Container,
    Divider,
    Grid,
    Modal,
    Paper,
    Typography,
} from "@material-ui/core";
import {Alert} from '@material-ui/lab';
import {navigate} from '@reach/router';
import { infoMap, urlFields, paramFields, subOfferFields } from '../utils/OfferMap';
import useTrafficStyles from "../styles/trafficStyles";
import PanelBox from "../components/TrafficSource/PanelBox";
import useFormInputs from "../hooks/useFormInputs";
import _ from "lodash";
import useFilterData from '../hooks/useFilterData';
import OfferURLTable from '../components/Offer/OfferURLTable';
import TrafficSourcesTable from "../components/TrafficSource/TrafficSourcesTable";
import RowChanges from '../utils/RowChanges';
import StepWizard from '../utils/StepWizard';
import useCustomApolloClient from "../apollo/useCustomApolloClient";
import SubOfferTable from "../components/Offer/SubOfferTable";
import VisibilityIcon from "@material-ui/icons/Visibility";

const Offer = ({ offerId }) => {
    const classes = useStyles();
    const trafficClasses = useTrafficStyles();
    const [isError, setIsError] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [editView, setEditView] = useState(offerId ? false : true);
    const [defaultValues, setDefaultValues] = useState({});
    const [openModal, setOpenModal] = useState({
        type: '',
        finalInputs: {}
    });
    const { findAdvertiserName, findGraphqlData, findOfferById, findWebsiteBaseUrl } = useFilterData();
    const [queryData, setQueryData] = useState({});
    const [manualLoad, setManualLoad] = useState(false);
    const [subOfferInputs, setSubOfferInputs] = useState([])
    const [defaultSubOfferInputs, setDefaultSubOfferInputs] = useState([])
    const [defaultTrafficSource, setDefaultTrafficSource] = useState(null)
    const [urlInputs, setUrlInputs] = useState([]);
    const [defaultUrlInputs, setDefaultUrlInputs] = useState([]);
    const { activeStep, renderWizard } = StepWizard();
    const { activeStep: subOfferActiveStep, renderWizard: subOfferRenderWizard } = StepWizard();
    const env = getEnvironment();

    const client = useCustomApolloClient()

    const onSubmit = () => {
        let error = false;
        setIsError(error);
        const errors = [];

        let nonRequiredFields = ['id', 'offerUrlQueryParameterId', 'deconstructUrlParameters', 'offerUrlQueryParameters', 'httpMethod'];
        infoMap.forEach((section) => {
            section.arr.forEach((item) => {
                if (!item.required) {
                    nonRequiredFields.push(item.key);
                }
            });
        });

        urlFields.forEach((section) => {
            section.arr.forEach((item) => {
                if (!item.required) {
                    nonRequiredFields.push(item.key);
                }
            });
        });

        paramFields.forEach((item) => {
            if (!item.required) {
                nonRequiredFields.push(item.key);
            }
        });

        Object.keys(inputs).forEach(key => {
            if (nonRequiredFields.includes(key)) {
                return
            }
            const value = inputs[key]
            if (!value) {
                errors.push('Please add values to the highlighted fields!')
                error = true
            }
        });

        urlInputs.forEach((urlInput) => {
            Object.keys(urlInput).forEach(key => {
                if (nonRequiredFields.includes(key)) {
                    return
                }
                const value = urlInput[key]
                if (!value && key !== 'activateTrafficSourceOfferUrls') {
                    error = true
                    errors.push('Please add values to the highlighted fields!')
                }
            });
            if (urlInput.offerUrlQueryParameters && urlInput.offerUrlQueryParameters.length) {
                urlInput.offerUrlQueryParameters.forEach((offerUrlQueryParameter) => {
                    offerUrlQueryParameter.forEach((paramField) => {
                        if (nonRequiredFields.includes(paramField['key'])) {
                            return
                        }
                        const value = paramField['value']
                        if (!value && (paramField['key'] !== 'offerUrlId' && paramField['key'] !== 'deleteFlag')) {
                            errorMessages.push(`${paramField['key']} is a required field.`)
                            error = true
                        }
                    })
                })
            } 
        })

        if (!error) {
            let finalInputs = {};
            for(const property in inputs){
                const val = inputs[property]
                if(val === null || val === undefined || val === "" || val === []){
                    continue;
                }

                if (property !== 'websiteBaseUrl') {
                    finalInputs[property] = inputs[property]
                }
            }
            finalInputs.advertiserId = findGraphqlData(queryData.allAdvertiser, finalInputs.advertiserId, 'name', 'id');
            finalInputs.offerUrls = [finalInputs.offerUrl];

            if (finalInputs.agencyFee === 'N/A') {
                finalInputs.agencyFee = 0.00
            } else if (finalInputs.agencyFee.includes('%')) {
                finalInputs.agencyFee = finalInputs.agencyFee.replace('%', '')
            }
 
            if (finalInputs.notes && finalInputs.notes.length) {
                finalInputs.offerNote = {
                    notes: finalInputs.notes,
                    delete: false
                };
            }  else {
                finalInputs.offerNote = {
                    notes: '',
                    delete: true
                };
            }  
            if (queryData.offer && queryData.offer.offerNote) {
                finalInputs.offerNote = {
                    ...finalInputs.offerNote,
                    id: queryData.offer.offerNote.id,
                    offerId: queryData.offer.offerNote.offerId
                };
            }

            finalInputs.offerUrls = urlInputs;
            delete finalInputs.offerUrl;
            delete finalInputs.notes;

            finalInputs.offerUrls.forEach((item, idx) => {
                const paramsArr = item.offerUrlQueryParameters || [];
                const originalDefaultUrlInputs = defaultUrlInputs[idx];
                if (paramsArr.length) {
                    item.offerUrlQueryParameters = paramsArr.map(((query, idx) => {
                        let arr = [];
                        let newObj = {};
                        query.forEach((obj => {
                            console.log(obj)
                            if (obj.key !== 'offerUrlQueryParameterId' && obj.key !== 'offerUrlId' &&  obj.key !== 'deleteFlag') {
                                newObj = {
                                    ...newObj,
                                    [obj.key]: obj.value,
                                };
                            } else if (obj.key === 'deleteFlag'){
                                newObj = {
                                    ...newObj,
                                    delete: obj.delete
                                };
                            }else {
                                newObj = {
                                    ...newObj,
                                    [obj.key]: obj[obj.key],
                                };
                            }
                            
                        }));

                        return newObj;
                    }));
                }
            });
            if(finalInputs.offerUrls.length) {
                finalInputs.offerUrls.forEach((offerUrl) => {
                    delete offerUrl.deconstructUrlParameters
                })
            }

            finalInputs.subOfferIds = subOfferInputs.map(item => item.offerId).filter(item => item);
            const website = queryData.allWebsite.find(website => website.baseUrl === inputs.websiteBaseUrl);
            finalInputs.websiteId =  website ? website.entityId : null;

            setOpenModal({
                type: 'edit',
                finalInputs
            });

        } else {
            setIsError(true);
            setErrorMessages(errors);
        }
    };

    const {
        clearAllInputs,
        inputs,
        handleSwitchChange,
        handleFilterChange,
        handleInputChange,
        handleSubmit, 
        setInputs
    } = useFormInputs(onSubmit);
    

    const setData = (objData, objKey) => {
        setInputs(inputs => ({
            ...inputs,
            id: objData[objKey] ? objData[objKey].id : '',
        }));

        let arr = [];
        infoMap.forEach(section => {
            section.arr.forEach((item => {
                const {key, type} = item

                if (inputs[item.key] === undefined) {
                    const dataKey = objData[objKey] ? objData[objKey][key] : '';
                    let value = dataKey === '' ? '' : dataKey;
                    
                    if (key === 'advertiserId') {
                        value = findAdvertiserName(objData[item.val], value);
                    }

                    if (key === 'websiteBaseUrl') {
                        if (objData.offer) {
                            value = findWebsiteBaseUrl(objData.allWebsite, objData.offer.websiteId);
                        }
                    }

                    if (key === 'notes') {
                        value = objData[objKey] && objData[objKey][item.val] ? objData[objKey][item.val][key] : '';
                    }

                    if (key === 'agencyFee') {
                        if (value <= 0) {
                            value = 'N/A'
                        } else {
                            value = `${value * 100}%`
                        }
                    }

                    setInputs(inputs => ({
                        ...inputs,
                        [key]: value
                    }));

                    setDefaultValues(inputs => ({
                        ...inputs,
                        [key]: value
                    }));
                }
            }));

        });
    };

    // const [fetchOffer, { loading: offerLoading, error: offerError, data: offerData }] = useLazyQuery(gql`
    //     query OfferPage($id: UUID!) {

    //         }`, {
    //     variables: {
    //         input: {
    //             id: offerId
    //         }
    //     },
    //     notifyOnNetworkStatusChange: true,
    //     client: client
    // });

    const [fetchOffer, { loading: offerLoading, error: offerError, data: offerData }] = useLazyQuery(gql`
        query OfferPage($input: OfferInput!, $id: UUID!) {
            allAdvertiser {
                id
                name
            }
            allSourceData: __type(name: "OfferUrlQueryParameterSourceData") {
                enumValues {
                    name
                }
            }
            offer (input: $input)  {
                offerId
                advertiserId
                offerName
                isHosted
                websiteId
                multiOffer
                everflowOfferId
                everflowOfferHash
                defaultTrafficSourceId
                agencyFee
                offerUrls {
                    offerUrlId
                    active
                    default
                    urlPath
                    url
                    name
                    httpMethod
                    offerId
                    forwardQueryParams
                    offerUrlQueryParameters {
                        constantValue
                        offerUrlQueryParameterId
                        offerUrlId
                        parameterName
                        sourceData
                    }
                }
                offerNote {
                    offerNoteId
                    notes
                    offerId
                }
                subOfferIds
            }
            allWebsite {
                name
                entityId
                baseUrl
            }
            allOffer {
                advertiserId
                offerId
                offerName
                agencyFee
                offerUrls {
                  httpMethod
                  offerUrlId
                  offerId
                  name
                  urlPath
                  url
                  active
                  default
                  forwardQueryParams
                  forwardQueryParams
                  offerUrlQueryParameters {
                    constantValue
                    offerUrlQueryParameterId
                    offerUrlId
                    parameterName
                    sourceData
                  }
                }
              }
            allTrafficSourceByOfferId(offerId: $id) {
                id
                name
                channel
                createdAt
                origin
                medium
                sourceUrl
                offerUrl
                legacyZoneId
                legacyPromoId
                legacyOfferId
                isDeleted
                affiliate {
                    id
                    name
                    key
                    legacyPublisherId
                }
                payoutStrategy {
                    id
                    enum
                }
                minimumPrice
                maximumPrice
                internal
                aggregatorOnly
                everflowAffiliateHash
                timeout
                isListManageable
                isTest
                proxyToOlp
                splitTest
                timeout
                includeS3InSource
                unsoldFeed
                soldFeed
                rootPingTree
                multiOffer
                multiConversion
                priceRejectMins {
                    mins
                }
                offer {
                    offerId
                    advertiserId
                    offerName
                    isHosted
                    websiteId
                    defaultTrafficSourceId
                    offerUrls {
                        offerUrlId
                        active
                        default
                        urlPath
                        url
                        name
                        httpMethod
                        offerId
                        forwardQueryParams
                        offerUrlQueryParameters {
                            constantValue
                            offerUrlQueryParameterId
                            offerUrlId
                            parameterName
                            sourceData
                        }
                    }
                    offerNote {
                        offerNoteId
                        notes
                        offerId
                    }
                    subOfferIds
                }
            }
        }
    `, {
        variables: {
            input: {
                id: offerId
            },
            id: offerId
        },
        notifyOnNetworkStatusChange: true,
        client: client
    });

    const [fetchDefault, { loading: defaultLoading, error: defaultError, data: defaultData }] = useLazyQuery(gql`
        query OfferPage {
            allOffer {
                advertiserId
                offerId
                offerName
                subOfferIds
                websiteId
                agencyFee
                offerUrls {
                  httpMethod
                  offerUrlId
                  offerId
                  name
                  urlPath
                  url
                  active
                  default
                  forwardQueryParams
                  offerUrlQueryParameters {
                    constantValue
                    offerUrlQueryParameterId
                    offerUrlId
                    parameterName
                    sourceData
                  }
                }
              }
            allAdvertiser {
                id
                name
            }
            allWebsite {
                name
                entityId
                baseUrl
            }
            allSourceData: __type(name: "OfferUrlQueryParameterSourceData") {
                enumValues {
                    name
                }
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
        client: client
    });

    const [createOffer, {loading: createOfferLoading, data: createOfferData}] = useMutation(gql`
        mutation createOffer($input: OfferMutator!) {
            createOffer(input: $input) {
                offerId
                advertiserId
                offerName
                subOfferIds
                agencyFee
                offerUrls {
                    offerUrlId
                    urlPath
                    url
                    name
                    httpMethod
                    offerId
                    default
                    active
                    forwardQueryParams
                    offerUrlQueryParameters {
                        constantValue
                        offerUrlQueryParameterId
                        offerUrlId
                        parameterName
                        sourceData
                    }
                }
                offerNote {
                    offerNoteId
                    notes
                    offerId
                }
            }
        }
    `, {
        client: client
    });


    const closeModal = () => {
        setOpenModal({
            type: '',
            finalInputs: {}
        });
    }

    useEffect(() => {
        if (createOfferData) {
            setTimeout(() => {
                closeModal();
                if (offerId) {
                    window.location.reload();
                } else if (createOfferData.createOffer.offerId) {
                    navigate(`/info/offers/${createOfferData.createOffer.offerId}`);
                    window.location.reload();
                }
            }, 3000);
        }
    }, [createOfferData])

    useEffect(() => {
        if (offerId) {
            fetchOffer();
        } else {
            fetchDefault();
        }
    }, []);

    useEffect(() => {
        if (defaultData && Object.keys(defaultData).length) {
            setQueryData(defaultData);
        }
    }, [defaultData]);

    useEffect(() => {
        const ready = offerData && Object.keys(offerData).length
        if (ready) {
            setQueryData({...offerData});
        }
    }, [offerData]);

    useEffect(() => {
        if (queryData && Object.keys(queryData).length) {
            setData(queryData, 'offer');

            if(offerId){
                const defaultTrafficSource = queryData.allTrafficSourceByOfferId.find(ts => ts.id === queryData.offer.defaultTrafficSourceId)
                setDefaultTrafficSource(defaultTrafficSource)
            }
        }
    }, [queryData]);

    useEffect(() => {
        if(editView) {
            setInputs({...inputs})
        }

        inputs["multiOffer"] = subOfferInputs.length > 0;
        setInputs({...inputs})
    }, [subOfferInputs]);

    if (defaultLoading || offerLoading || !Object.keys(queryData).length || createOfferLoading || manualLoad) {
        return (
            <Backdrop className={classes.backdrop} open={true}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
    }

    if (offerError || defaultError) {
        return (
            <Paper className={classes.paper}>
                <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                <p>
                    <a href="/#" onClick={(e) => {
                        e.preventDefault();
                        navigate('/info/offers');
                    }}>Click here to view all offers.</a>
                </p>
            </Paper>
        );
    }

    const renderUrls = () => {
        return (
            <>
                {urlInputs.map((url, idx) => {
                    if (activeStep === idx) {
                        return (
                            <Fragment key={idx.toString()}>
                                {urlFields.map(section => (
                                    <RowChanges
                                        key={section.title}
                                        rowData={section}
                                        currentValues={url}
                                        defaultValues={defaultUrlInputs[idx]}
                                    />
                                ))}
                            </Fragment>
                        );
                    }
                    return null;
                })}
            </>
        );
    };

    const renderSubOffers = () => {
        return (
            <>
                {subOfferInputs.map((subOffer, idx) => (
                        <Fragment key={idx.toString()}>
                            {subOfferFields.map(section => (
                                <RowChanges
                                    key={section.title}
                                    rowData={section}
                                    currentValues={subOffer}
                                    defaultValues={defaultSubOfferInputs[idx]}
                                />
                            ))}
                        </Fragment>
                    )
                )}
            </>
        );
    };

    return (    
        <>
            <Typography variant="h2" component="h2" className={classes.monospace}>
                {queryData && queryData.offer ? `Offer -  ${queryData.offer.offerName}` : 'Add Offer'}
            </Typography>
            {errorMessages && errorMessages.length ? errorMessages.map((error) => {
                    return (<Alert severity="error">{error}</Alert>)
                }
            ) : null}
            <Paper className={classes.paper}>
                <Container maxWidth={false}>
                    <Box className={trafficClasses.headerBox}>
                        {env === 'test' ? (
                            <Box display="flex" justifyContent="end" style={{ margin: '15px 5px'}}>
                                {!editView ? (
                                    <>
                                        <Button variant="contained" color="secondary"
                                                onClick={() => setEditView(true)}>
                                            Edit
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button variant="contained" color="primary" onClick={() => handleSubmit()} style={{ marginRight: '5px' }}>
                                            {offerId ? 'Save Changes' : 'Create New'}
                                        </Button>
                                        {offerId ? (
                                            <Button variant="contained" color="secondary" onClick={() => {
                                                setInputs(defaultValues);
                                                setEditView(false);
                                            }}>
                                                Cancel
                                            </Button>
                                        ) : null}
                                    </>
                                )}
                            </Box>
                        ) : null}
                        <Grid container spacing={3}>
                            {infoMap.map((section, idx) => (
                                section.title &&
                                <Grid item xs={12} md={6} key={`${section.title} -${idx.toString()}`}>
                                    <PanelBox
                                        panelData={section}
                                        trafficClasses={trafficClasses}
                                        editView={editView}
                                        inputs={inputs}
                                        data={queryData}
                                        handleFilterChange={handleFilterChange}
                                        handleInputChange={handleInputChange}
                                        handleSwitchChange={handleSwitchChange}
                                        setInputs={setInputs}
                                        rowCol={12}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {defaultTrafficSource ?
                        <Box className={trafficClasses.headerBox} style={{textAlign: 'left'}}>
                            <Typography variant="h6" component="h6" className={classes.monospace}>
                                <strong>Default Traffic Source</strong>
                                <div style={{display: "flex", justifyContent:'flex-start', alignItems:'center', marginTop: 10}} >
                                    <VisibilityIcon style={{marginRight: 5, cursor: 'pointer'}} onClick={() => window.open("/info/traffic-sources/" + defaultTrafficSource.id)}/>
                                    <Typography style={{paddingBottom: 0}}>
                                        {/*<a target="_blank" rel="noopener noreferrer" */}
                                        {/*   href={"/info/traffic-sources/" + defaultTrafficSource.id}>*/}
                                        {/*    */}
                                        {/*</a>*/}
                                        {defaultTrafficSource ? defaultTrafficSource.name : null}
                                    </Typography>
                                </div>
                            </Typography>
                        </Box>
                        : null
                    }

                    <Box className={trafficClasses.headerBox} style={{ textAlign: 'left' }}>
                        <Typography variant="h6" component="h6" className={classes.monospace}>
                            <strong>Sub Offers</strong>
                        </Typography>
                        <SubOfferTable
                            data={queryData}
                            inputs={inputs}
                            creatingNew={!offerId}
                            editView={editView}
                            handleSwitchChange={handleSwitchChange}
                            handleInputChange={handleInputChange}
                            setInputs={setInputs}
                            offerInputs={subOfferInputs}
                            setOfferInputs={setSubOfferInputs}
                            defaultOfferInputs={defaultSubOfferInputs}
                            setDefaultOfferInputs={setDefaultSubOfferInputs}
                            findOfferById={findOfferById}
                            findAdvertiserById={findAdvertiserName}
                        />
                    </Box>
                    <Box className={trafficClasses.headerBox} style={{ textAlign: 'left' }}>
                        <Typography variant="h6" component="h6" className={classes.monospace}>
                            <strong>Offer URLs</strong>
                        </Typography>
                        <OfferURLTable 
                            data={queryData}
                            urls={queryData.offer ? queryData.offer.offerUrls : []} 
                            editView={editView}
                            inputs={inputs}
                            setInputs={setInputs}
                            setDefaultValues={setDefaultValues}
                            handleFilterChange={handleFilterChange}
                            handleSwitchChange={handleSwitchChange}
                            urlInputs={urlInputs}
                            setUrlInputs={setUrlInputs}
                            defaultUrlInputs={defaultUrlInputs}
                            setDefaultUrlInputs={setDefaultUrlInputs}
                            hasTrafficSourceByOffers={queryData.allTrafficSourceByOfferId && queryData.allTrafficSourceByOfferId.length ? true : false}
                        />
                    </Box>
                    <Box className={trafficClasses.headerBox} style={{ textAlign: 'left', maxHeight: '300px' }}>
                        {editView && offerId ? (
                            <Button variant="contained" color="primary" onClick={(e) => {
                                e.preventDefault();
                                navigate(`/info/traffic-sources/add/offerId/${offerId}`);
                            }}>
                                Add Traffic Source
                            </Button>
                        ) : null}
                        <Typography variant="h6" component="h6" className={classes.monospace}>
                            <strong>Traffic Sources</strong>
                        </Typography>
                        {queryData.allTrafficSourceByOfferId ? <TrafficSourcesTable
                            trafficSources={queryData.allTrafficSourceByOfferId.filter((trafficSource) => !trafficSource.isDeleted)}
                            actions={['view']}
                        /> : null}
                    </Box>
                </Container>
                <Modal
                    open={openModal.type !== ''}
                    onClose={closeModal}
                >
                    <Container className={`${classes.modal} ${trafficClasses.modal} `} maxWidth={false}>
                        <Typography variant="h5" align="center" gutterBottom>
                            Please confirm your traffic source changes
                        </Typography>
                        <Paper className={classes.paper} style={{marginBottom: 0}}>

                            <Box>
                                <Grid container className="row-grid">
                                    <Grid item xs={4}/>
                                    <Grid item xs={4}>
                                        <Typography variant="subtitle1" align="center">
                                            CURRENT CHANGES
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="subtitle1" align="center">
                                            NEW CHANGES
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box>
                                {infoMap.map(section => (
                                    <RowChanges
                                        key={section.title}
                                        rowData={section}
                                        currentValues={inputs}
                                        defaultValues={defaultValues}
                                    />
                                ))}
                            </Box>
                            <Divider />
                            <Box style={{ margin: '20px 0 30px'}}>
                                {renderSubOffers()}
                            </Box>
                            <Box style={{ margin: '20px 0 30px'}}>
                                <Alert severity="warning">Use the navigation buttons to confirm the url ({urlInputs.length} changes)</Alert>
                                {renderWizard(renderUrls(), urlInputs.length)}
                            </Box>
                            <Divider />
                            <Grid item xs className={trafficClasses.headerButtons}>
                                <Button variant="contained" color="primary" onClick={(e) => {
                                    e.preventDefault();
                                    createOffer({
                                        variables: {
                                            input: {
                                                id: offerId,
                                                ...openModal.finalInputs
                                            }
                                        }
                                    });
                                    setManualLoad(true);
                                }}>
                                    Save
                                </Button>
                                <Button variant="outlined" onClick={() => {
                                    closeModal();
                                    setInputs(defaultValues);
                                    setEditView(false);
                                }}>
                                    Cancel
                                </Button>
                            </Grid>
                        </Paper>
                    </Container>
                </Modal>
            </Paper>
        </>
    )
};

export default Offer;